<template>
	<div>
		<div class="filter-tag-row">
			<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Услуги: {{this.masApi_total}}</span>
		</div>
		<div class="row" v-show="bShowFilter">
			<div class="col-12"><ReFilter :masAllFilterParams="masAllFilterParams" v-model="objGetParams" v-on:filterapply="OnFilterApply"/></div>
		</div>
		<ReServiceMultiOp :masServices="masApi" @change="OnFilterApply"/>

		<div class="row" style="align-items: center;">
			<Pagination :class="[{'': parseInt(masApi_total) > 0}, {'d-none': parseInt(masApi_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masApi_total)" 
				:perPage="parseInt(c2p)" 
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination>

			<div class="d-flex">
				<label><p>Показывать по:</p></label>
				<el-select
					style="margin-top: -5px; width: 80px;"
					class="select-primary overflow-overlay ml-1"
					placeholder="Количество элементов на странице"
					v-model="c2p"
					@change="OnFilterApply"
				>
					<el-option
						v-for="(el_opt, el_index) in c2p_options"
						class="select-primary"
						:value="el_opt.value"
						:label="el_opt.label"
						:key="el_index"
					>
					</el-option>
				</el-select>
			</div>
		</div>
	</div>
</template>
<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReServiceMultiOp from 'src/our_components/ReServiceMultiOp.vue';
import Pagination from 'src/our_components/RePagination';
import { Select, Option } from 'element-ui';

export default {
	name: 'Services_group_op-page',
	components: {
		ReFilter,
		ReFilterBtn,
		ReServiceMultiOp,
		Pagination,
		[Option.name]: Option,
		[Select.name]: Select,
	},
	data() {
		return {
			ApiData: {},
			objGetParams: {},
			masAllFilterParams: this.currentFilterConfig(),
			bShowFilter: false,
			masApi: [],
			masApi_total:0,
			c2p:100,
			c2p_options:[{'value':10,'label':'10'},{'value':20,'label':'20'},{'value':50,'label':'50'},{'value':100,'label':'100'}],
		};
	},
	methods: {
		getApi(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				// console.log('getApi',this.objGetParams);
				filter = this.objGetParams;
			}
			//console.log('getApi',filter);
			this.$GVO.ApiCall('GET_SERVICES_BY_AGENT',{obj:'services' ,flt:{...filter,...{c2p:this.c2p}} })
			.then((objApi) => { 
				this.masApi_total=0;
				this.masApi = [];
				if(objApi.success === true){ //console.log(objApi);
					this.masApi = objApi.data;
					if(objApi.total!=undefined) { this.masApi_total=objApi.total; }
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('GET_FILTER_SERVICES_GO',{obj:'services'})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFilterParams = objApi.config;
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		OnFilterApply(data){
			//this.objGetParams = data;
			//console.log('OnFilterApply',data);
			// console.log('OnFilterApply',this.objGetParams);
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApi();
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
	},
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		//this.getApi();
	}
};
</script>
<style>
</style>
